<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="1100">
    <template v-slot:title>{{ title }}</template>
    <v-row>
      <v-col>
        <v-text-field
          label="Name"
          v-model="name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Code"
          v-model="code"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <taxes-list-select
          v-model="taxCode"
          :outlined="outlinedInputs"
        ></taxes-list-select>
      </v-col>
      <v-col class="py-0">
        <rate-type-list-select
          v-model="rateTypeCode"
          :outlined="outlinedInputs"
          hideNotInUse
        ></rate-type-list-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox
          label="Accommodation"
          v-model="isAccommodation"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox
          label="Activity"
          v-model="isActivity"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox
          label="Transport"
          v-model="isTransport"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox label="Travel" v-model="isTravel" hide-details></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox label="Other" v-model="isOther" hide-details></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox
          label="Package"
          v-model="isPackage"
          hide-details
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-checkbox
          label="Child Only"
          v-model="isChildOnly"
          hide-details
          @change="onChildOnlyChange"
        ></v-checkbox>
      </v-col>
      <v-col class="py-0">
        <v-checkbox
          label="Infant Only"
          v-model="isInfantOnly"
          hide-details
          @change="onInfantOnlyChange"
        ></v-checkbox>
      </v-col>
      <v-col class="py-0">
        <v-checkbox
          label="Mandatory"
          v-model="isMandatory"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col class="py-0">
        <v-checkbox
          label="Commission"
          v-model="commission"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col class="py-0">
        <v-checkbox
          label="No Report"
          v-model="noReport"
          hide-details
        ></v-checkbox>
      </v-col>

      <v-col class="py-0">
        <v-checkbox
          label="Discount"
          v-model="discount"
          hide-details
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row
      ><v-col class="pt-0" cols="2">
        <v-checkbox label="Markup" v-model="markup" hide-details></v-checkbox>
      </v-col>
      <v-col class="pt-0" cols="2">
        <v-checkbox
          label="Capacity Change"
          v-model="capacityChange"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col class="pt-0" cols="2">
        <v-checkbox
          label="Not In Use"
          v-model="notInUse"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col class="py-0" cols="2">
        <v-checkbox
          label="No Voucher"
          v-model="noVoucher"
          hide-details
        ></v-checkbox>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import TaxesListSelect from "../../shared/TaxesListSelect.vue";
import RateTypeListSelect from "../../shared/RateTypeListSelect.vue";
export default {
  name: "ExtraTypeEditDialog",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: {
    BasicDialog,
    TaxesListSelect,
    RateTypeListSelect,
  },

  data() {
    return {
      name: this.value ? this.value.name : "New Extra Type",
      code: this.value ? this.value.code : "",
      taxCode: this.value ? this.value.taxCode : "",
      rateTypeCode: this.value ? this.value.rateTypeCode : "",
      capacityChange: this.value && this.value.capacityChange ? true : false,
      isAccommodation: this.value && this.value.isAccommodation ? true : false,
      isActivity: this.value && this.value.isActivity ? true : false,
      isTransport: this.value && this.value.isTransport ? true : false,
      isTravel: this.value && this.value.isTravel ? true : false,
      isOther: this.value && this.value.isOther ? true : false,
      isPackage: this.value && this.value.isPackage ? true : false,
      commission: this.value && this.value.commission ? true : false,
      markup: this.value && this.value.markup ? true : false,
      noReport: this.value && this.value.noReport ? true : false,
      discount: this.value && this.value.discount ? true : false,
      isChildOnly: this.value && this.value.isChildOnly ? true : false,
      isInfantOnly: this.value && this.value.isInfantOnly ? true : false,
      isMandatory: this.value && this.value.isMandatory ? true : false,
      notInUse: this.value && this.value.notInUse ? true : false,
      noVoucher: this.value && this.value.noVoucher ? true : false,
    };
  },

  computed: {
    title() {
      return this.value ? "Edit Extra Type" : "New Extra Type";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.name != "" &&
        this.code != "" &&
        this.taxCode != "" &&
        this.rateTypeCode != ""
      );
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal ? newVal.name : "New Extra Type";
      this.code = newVal ? newVal.code : "";
      this.taxCode = newVal ? newVal.taxCode : "";
      this.rateTypeCode = newVal ? newVal.rateTypeCode : "";
      this.capacityChange = newVal && newVal.capacityChange ? true : false;
      this.isAccommodation = newVal && newVal.isAccommodation ? true : false;
      this.isActivity = newVal && newVal.isActivity ? true : false;
      this.isTransport = newVal && newVal.isTransport ? true : false;
      this.isTravel = newVal && newVal.isTravel ? true : false;
      this.isOther = newVal && newVal.isOther ? true : false;
      this.isPackage = newVal && newVal.isPackage ? true : false;
      this.commission = newVal && newVal.commission ? true : false;
      this.noReport = newVal && newVal.noReport ? true : false;
      this.discount = newVal && newVal.discount ? true : false;
      this.markup = newVal && newVal.markup ? true : false;
      this.isChildOnly = newVal && newVal.isChildOnly ? true : false;
      this.isInfantOnly = newVal && newVal.isInfantOnly ? true : false;
      this.isMandatory = newVal && newVal.isMandatory ? true : false;
      this.notInUse = newVal && newVal.notInUse ? true : false;
    },
  },

  methods: {
    onChildOnlyChange(payload) {
      if (payload) {
        this.isInfantOnly = false;
      }
    },
    onInfantOnlyChange(payload) {
      if (payload) {
        this.isChildOnly = false;
      }
    },
    onSave() {
      const input = {
        id: this.value ? this.value.id : null,
        name: this.name,
        code: this.code,
        taxCode: this.taxCode,
        rateTypeCode: this.rateTypeCode,
        capacityChange: Number(this.capacityChange),
        isAccommodation: this.isAccommodation,
        isActivity: this.isActivity,
        isTransport: this.isTransport,
        isTravel: this.isTravel,
        isOther: this.isOther,
        isPackage: this.isPackage,
        commission: this.commission,
        markup: this.markup,
        noReport: this.noReport,
        discount: this.discount,
        isChildOnly: this.isChildOnly,
        isInfantOnly: this.isInfantOnly,
        isMandatory: this.isMandatory,
        notInUse: this.notInUse,
        noVoucher: this.noVoucher,
      };
      this.$emit("input", input);
      this.$emit("save", input);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/ExtraTypeEditDialog.vue